// possible discounts
export default {
  buy5pay4: 'buy5pay4',
}
